import logsRoutes from './routes';
import logsSlice, { logsMiddleware } from './store/logs.store';

export { logsRoutes };

const moduleConfig = {
  routes: logsRoutes,
  middleware: [logsMiddleware],
  reducers: {
    organization: logsSlice.reducer,
  },
};

export default moduleConfig;
